import type { HTMLAttributes, PropsWithChildren } from "react";
import { Children } from "react";

import { css } from "@compiled/react";

import { useTabsContext, TabFC, mapChild } from "./";

export type TabPanelProps = PropsWithChildren<{
    forceRender?: boolean;
    panelIndex?: number;
}> &
    HTMLAttributes<HTMLDivElement>;

const hidePanelStyle = css({
    display: "none"
});

const TabPanel: TabFC<TabPanelProps> = ({
    forceRender,
    children,
    panelIndex,
    id,
    ...props
}: TabPanelProps) => {
    const { isCurrentTab } = useTabsContext();

    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";

    return (
        <div
            {...props}
            css={[!isTabSelected && !forceRender && hidePanelStyle]}
            id={`panel${id}`}
            aria-labelledby={`tab${id}`}
            aria-hidden={!isTabSelected}
            role="tabpanel"
            className={["tab-panel", activeClass].join(" ")}
        >
            {Children.map(children, (child) => {
                return mapChild(child, { isPanelActive: isTabSelected });
            })}
        </div>
    );
};
TabPanel.tabsRole = "TabPanel";

export { TabPanel };
